import {MessageCodes} from "../MessageCodes";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultView from "../../../components/ResultView";
import HecRasHelper from "../../../helpers/HecRasHelper";

export function CFW2({data, message_key}) {
    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} globalVariables={data?.global_variables}/>
                    </ResultView>
                ))
            }
        </>
    )
}

const TwoRowTable = ({basePlanTitle, compPlanTitle, baseValue, compValue}) => (
    <ResultTable>
        <ResultBody>
            <ResultRow>
                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(25)}}>{basePlanTitle}</ResultHeaderCell>
                <ResultBodyCell style={{textAlign: 'left'}}>{baseValue}</ResultBodyCell>
            </ResultRow>
            <ResultRow>
                <ResultHeaderCell style={{textAlign: 'left'}}>{compPlanTitle}</ResultHeaderCell>
                <ResultBodyCell style={{textAlign: 'left'}}>{ResultCellHighlight(baseValue, compValue)}</ResultBodyCell>
            </ResultRow>
        </ResultBody>
    </ResultTable>
)

const HEADLINES = {
    'C-FW 03': 'There are differences in the Conveyance Calculation Method',
    'C-FW 04': 'There are differences in the Friction Slope Method for Steady Flow',
    'C-FW 05': 'There are differences in the HEC-RAS Calculation Tolerances',
    'C-FW 06': 'Critical Depth Always Calculated',
    'C-FW 07': 'Critical Depth Calculation Method',
}

const Description = ({row, globalVariables}) => {
    const basePlanTitle = globalVariables?.sel_plan_title || 'Base Plan'
    const compPlanTitle = globalVariables?.tar_plan_title || 'Comparison Plan'
    const item = row?.data?.[0]
    const headline = HEADLINES[row?.error_id]

    switch (row?.error_id) {
        case MessageCodes.Compare.CFW03.error_id:
        case MessageCodes.Compare.CFW04.error_id:
        case MessageCodes.Compare.CFW06.error_id:
        case MessageCodes.Compare.CFW07.error_id: {
            return (
                <>
                    <ResultText>
                        {headline}
                        <EmptyLine/>
                    </ResultText>
                    <TwoRowTable
                        basePlanTitle={basePlanTitle}
                        compPlanTitle={compPlanTitle}
                        baseValue={item?.base_value}
                        compValue={item?.comp_value}
                    />
                </>
            )
        }
        case MessageCodes.Compare.CFW05.error_id: {
            return (
                <>
                    <ResultText>
                        {headline}
                        <EmptyLine/>
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3} style={{textAlign: 'center'}}>
                                    HEC-RAS Calculation Tolerances
                                </ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Calculation</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>{basePlanTitle}</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>{compPlanTitle}</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>{r.label}</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.base_value}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.base_value, r.comp_value)}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default:
            return null
    }
}
